export const KPI_THEME = {
  name: 'kpi',
  base: 'default',
  variables: {
    primary: '#3a546b',
    secondary: '#ff6c6c',
  },
};
